import { render } from "./GlobalErrorModal.vue?vue&type=template&id=1f1645da&scoped=true"
import script from "./GlobalErrorModal.vue?vue&type=script&lang=js"
export * from "./GlobalErrorModal.vue?vue&type=script&lang=js"

import "./GlobalErrorModal.vue?vue&type=style&index=0&id=1f1645da&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f1645da"]])

export default __exports__